import React from 'react';

import { Box, Spinner } from '@amzn/awsui-components-react-v3';

import clsx from 'clsx';

import { MPNOptions } from './MPNOptions';

interface MPNAutoSuggestionProps {
  suggestions: any;
  hideSuggest: boolean;
  mpnInput: string;
  activeIndex: number;
  onHandleClickOption: (val: string) => void;
}

export const MPNAutoSuggestion =
  ({ suggestions, hideSuggest, mpnInput, activeIndex, onHandleClickOption }: MPNAutoSuggestionProps) => {
    const isLoading = (suggestions?.loading || (suggestions?.values?.length === 0 && mpnInput?.length > 3 && !hideSuggest));
    return (
      <div className="mpn-auto-suggest">
        <div
          className={clsx('mpn-auto-suggest-container', {
            loaded: (suggestions?.loading || suggestions?.values?.length > 0 || mpnInput?.length > 0) && !hideSuggest,
          })}
        >
          <Box>
            {isLoading && (
              <Box padding="m">
                <Spinner /> <Box variant="span">loading MPN...</Box>
              </Box>
            )}
            {suggestions?.error && (
              <Box padding="m">
                <Box variant="span" color="text-status-error">
                  Error occured while fetching the mpn
                </Box>
              </Box>
            )}
            <MPNOptions
              mpnInput={mpnInput}
              suggestions={suggestions}
              onClick={onHandleClickOption}
              activeIndex={activeIndex}
              hideSuggest={hideSuggest}
            />
          </Box>
        </div>
      </div>
    );
  };
